module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tm-header"
  }, [_c('div', {
    staticClass: "uk-navbar-container uk-navbar-transparent",
    attrs: {
      "animation": "uk-animation-slide-top"
    }
  }, [_c('div', {
    staticClass: "uk-container uk-container-large"
  }, [_c('div', {
    staticClass: "uk-navbar",
    attrs: {
      "uk-navbar": ""
    }
  }, [_c('div', {
    staticClass: "uk-navbar-left"
  }, [_c('a', {
    staticClass: "uk-navbar-item uk-logo",
    attrs: {
      "target": "_blank",
      "href": "https://help.artsdoor.net/"
    }
  }, [_c('img', {
    staticClass: "uk-responsive-height",
    attrs: {
      "src": require("../assets/logo.png"),
      "alt": "Juno"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "uk-navbar-center"
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-navbar-right"
  }, [_c('div', {
    staticClass: "uk-navbar-item"
  }, [_c('div', {
    staticClass: "custom contactus"
  }, [_c('a', {
    staticClass: "uk-button uk-button-text",
    attrs: {
      "href": "#Contact"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-xin"
  }), _vm._v(" 联系我们")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e7417d2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Top.vue
// module id = 96
// module chunks = 1